import * as React from 'react';
import { useAccountDropdownContext } from './AccountDropdownProvider';
import { useAccountDropdownBundle } from 'src/providers/PantherLocalizationProvider';
import { findSelectedAccountSwitcherAccount } from './accountHelper';
import {
  AccountDropdownTriggerCommon,
  AccountDropdownTriggerProps,
  getAccountTypeLabel,
} from './AccountDropdownTriggerCommon';

export const IA2AccountDropdownTrigger: React.FC<
  AccountDropdownTriggerProps
> = ({ handleToggle, isOpen }) => {
  const {
    currentAccountName,
    currentAccountType,
    currentMarketplaceId,
    currentEntityId,
    accounts,
    loadingStatus,
    accountCounter,
  } = useAccountDropdownContext();
  const bundle = useAccountDropdownBundle();
  if (loadingStatus === 'success' && accountCounter === 0) return null;
  const selectedAccount =
    accounts &&
    findSelectedAccountSwitcherAccount(
      currentEntityId,
      accounts.map((accountGroup) => accountGroup.accounts).flat(),
    );
  const accountName = selectedAccount?.label || currentAccountName;
  const isTriggerEnabled = loadingStatus !== 'loading';

  const marketplaceLabel = getAccountTypeLabel({
    accounts,
    currentEntityId,
    currentAccountType,
    currentMarketplaceId,
    bundle,
  });
  const allAcountsLabel = bundle.getMessage(
    'account-switcher-all-accounts-label',
  );

  return (
    <AccountDropdownTriggerCommon
      accountName={accountName}
      marketplaceLabel={marketplaceLabel}
      allAcountsLabel={allAcountsLabel}
      isTriggerEnabled={isTriggerEnabled}
      isOpen={isOpen}
      handleToggle={handleToggle}
    />
  );
};
